import api, { downloadUrl } from '../api';

export default {
  namespaced: true,
  state: {
    downloadConfig: {
      // form下载
      baseUrl: downloadUrl,
      action: '',
      info: [{ name: '', value: '' }],
    },
  },
  mutations: {
    setStateDownloadConfig(state, info) {
      info.info.push({ name: 'token', value: localStorage.getItem('token') });

      state.downloadConfig = Object.assign({}, state.downloadConfig, info);
      setTimeout(() => {
        document.getElementById('download').submit();
        state.downloadConfig = Object.assign({}, state.downloadConfig, {
          action: '',
          info: [],
        });
      }, 30);
    },
  },
  actions: {
    /**
     *  let params = new FormData();
     *  params.append('product', '0');
     *  params.append('type', '6');
     *  params.append('lang', 'zh_CN');
     *  params.append('file', this.imgFile);
     * */
    getRegeo(store, location) {
      return api.map_get('/v3/geocode/regeo', '逆地理编码', { location }).then((res) => {
        if (res.status === '1') {
          let addressComponent = res.regeocode.addressComponent;
          return `${addressComponent.country}-${addressComponent.province}-${addressComponent.city}`;
        } else {
          return '';
        }
      });
    },
    uploadImg(store, params) {
      return api.upload('/upload/banner', '图片上传', params);
    },
    sendCode(store, params) {
      return api.post('/sms/sendCode', '发送短信验证码', params);
    },
    sendCodeToMyPhone(store, { err, type }) {
      return api
        .post(`/sms/sendCodeToMyPhone/${type}`, '发送短信验证码到用户的手机')
        .then(() => {})
        .catch(() => {
          err();
        });
    },
  },
};
